module.exports = __webpack_public_path__ + "e0106718/img/settings-ico.a214628d.svg";